const locale = require('../../../../../core/app/core.i18n.json');

/*@ngInject*/
const RecentActivityController = function ($scope, $rootScope, $controller, landingMediator, coreConstant, landingConstant, submissionGridConstant, appTypeConfigurationModel, advancedFilterType, authorizationConstants, persistentConnection, gridColumnModel, localization, currentUserModel, coreMediator) {

    angular.extend(this, $controller('baseGridWidgetController', {$scope: $scope}));
    this.i18n = locale;

    this.advancedFilterType = advancedFilterType.ACTIVITY_GRID;
    this.recentActivityList = [];
    this.showPaging = false;
    this.isLoaded = false;

    this.$onInit = function () {
        this.gridLoadedEvent = landingConstant.event.ACTIVITIES_LOADED;
        this.requestParams = this.getFilterParams();

        this.userId = currentUserModel.getCurrentUser().userId;
        this.hasFilterPermission = currentUserModel.hasAuthorization(authorizationConstants.AUTHORIZATION_ADVANCED_FILTER);

        this.onInitGridWidget();
    };

    localization.getTranslationByKey('homePage.grid').then((translations) => {
        this.recordCountText = _.get(translations, 'submissionCount');
        this.recordsCountText = _.get(translations, 'submissionsCount');
        this.showOrHideToolsTooltip = _.get(translations, 'showOrHideToolsTooltip');
        this.searchIconTooltip = _.get(translations, 'searchIconTooltip');
    });

    this.onPagingChange = function ($event, params) {
        this.requestParams.pageSize = params.pageSize;
        this.requestParams.startIndex = params.startIndex;
        this.loadRecords();
    };

    this.loadRecordsInt = function (requestParams) {
        return landingMediator.loadRecentActivityList(requestParams).then((result) => {
            let recentActivityList = [];

            // Map recent activity collection down to the latest entry per submission
            recentActivityList = result.records;
            recentActivityList = _.chain(recentActivityList).orderBy(['triggerTime'], ['desc']).value();
            recentActivityList = _.groupBy(recentActivityList, 'submissionId');
            recentActivityList = _.chain(recentActivityList).orderBy(['0.triggerTime'], ['desc']).value();
            this.recentActivityList = recentActivityList;
            /*
             * If the server returns totalRecords as -1, that means that
             * the client should use the previous totalRecords value.
             */
            if (result.totalRecords === -1) {
                result.totalRecords = this.savedTotalRecords;
            }
            this.totalRecords = result.totalRecords;
            if (this.totalRecords >= 0) {
                this.savedTotalRecords = this.totalRecords;
            }
            this.showPaging = this.totalRecords > requestParams.pageSize;
            this.isGridEmpty = this.records.length === 0;
            this.isLoading = false;
            this.isLoaded = true;
            this.recalculateGridPaging();
            return result;
        });
    };

    this.recalculateGridPaging = function () {
        $scope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
    };

    $scope.getRecentActivityMessage = (activityItem) => {
        let message = activityItem.note.simpleMessage;
        message += ' by ' + activityItem.actorDisplayName;

        if (activityItem.note.statusReason && !this.isAgent) {
            message += ' - ' + activityItem.note.statusReason;
        }

        if (activityItem.note.statusDetail && !this.isAgent) {
            message += ' - ' + activityItem.note.statusDetail;
        }

        return message;
    };

    $scope.toggleGroup = function (activityItem) {
        activityItem.isOpen = !activityItem.isOpen;
    };

    this.setOpenFilterUri = function (filterUri) {
        gridColumnModel.setOpenFilterUri(this.advancedFilterType, filterUri);
    };

    this.getOpenFilterUri = function () {
        return gridColumnModel.getOpenFilterUri(this.advancedFilterType);
    };

    this.setFilterParams = function (filterParams) {
        gridColumnModel.setActivityParams(filterParams);
    };

    this.getFilterParams = function () {
        return gridColumnModel.getActivityParams();
    };

    this.setSelectedFilterName = function (filterName) {
        gridColumnModel.setSelectedActivityFilterName(filterName);
    };

    this.getSelectedFilterName = function () {
        return gridColumnModel.getSelectedActivityFilterName();
    };

    this.loadListOnFilterChange = function () {
        this.openFilter = null;
        this.calculateFilterParams();
        this.resetGridPaging();
    };

    this.initLandingPage = function () {
        this.shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
        this.updateDefaultSortColumn();
        this.updateColumnsFromPreferences();
        this.generateColumns();
        this.updateFilterFromPreferences();
    };

    $scope.$on(submissionGridConstant.event.RESET_GRID_COLUMNS, () => {
        this.updateColumnsFromPreferences();
        this.resetGridColumns();
    });

    $scope.$on(submissionGridConstant.event.RESET_GRID_LIST, () => {
        this.loadListOnFilterChange();
    });

    $scope.$on(coreConstant.event.USERTYPE_UPDATED, () => {
        persistentConnection.connect().then(() => {
            this.isUserTypeUpdated = true;
            this.isAgent = appTypeConfigurationModel.isAgentConsole();
            this.initLandingPage();
        });
    });

    $scope.$on(coreConstant.event.FILTER_SAVED, this.handleFilterSave.bind(this));
};

angular.module('umLanding')
    .controller('recentActivityController', RecentActivityController);
